import { render } from "./GoogleImageDisplay.vue?vue&type=template&id=fa061d8a"
import script from "./GoogleImageDisplay.vue?vue&type=script&lang=js"
export * from "./GoogleImageDisplay.vue?vue&type=script&lang=js"

import "./GoogleImageDisplay.vue?vue&type=style&index=0&id=fa061d8a&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__